import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';
import { validateAcceptInviteSearch } from '../-publicSearch';

const LazyAcceptInvite = lazy(() => import('./-invite').then((module) => ({ default: module.AcceptInvite })));

const AcceptInviteRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyAcceptInvite />
  </Suspense>
);

export const Route = createFileRoute('/accept-invite/$inviteId')({
  beforeLoad: async ({ context }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
    }
  },
  component: AcceptInviteRouteComponent,
  validateSearch: validateAcceptInviteSearch,
});
